<template>
  <div>
    <h2 v-bg-typography="'h2'">
      {{ boldTitle }}
      <span class="page-section__normal-part">{{ normalTitle }}</span>
    </h2>
  </div>
</template>

<style scoped>
.page-section__normal-part {
  font-weight: 500;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";

export default {
  name: "base-page-section-title",
  directives: {
    BgTypography,
  },
  props: {
    boldTitle: {
      type: String,
      requred: false,
      default: "",
    },
    normalTitle: {
      type: String,
      requred: false,
      default: "",
    },
  },
};
</script>
